const ChartSkeleton = ({ delay = "0s" }) => {
  return (
    <div 
      className="col-xl-4 col-lg-6 col-md-12 mb-4 animate-fade-in" 
      style={{ animationDelay: delay, marginBottom: '2rem !important' }}
    >
      <div className="card h-100 border-0 shadow-sm">
        {/* Header Skeleton */}
        <div className="card-header bg-white border-0 pb-0">
          <div className="d-flex justify-content-between align-items-start">
            <div className="flex-grow-1">
              <div className="placeholder-glow">
                <span className="placeholder col-7 mb-2 rounded" style={{ height: '24px' }}></span>
                <span className="placeholder col-9 rounded" style={{ height: '16px' }}></span>
              </div>
            </div>
            <span className="placeholder col-2 rounded-pill" style={{ height: '24px' }}></span>
          </div>
        </div>

        {/* Body Skeleton */}
        <div className="card-body pt-2">
          {/* Chart Circle Skeleton */}
          <div className="text-center mb-3">
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
              <div className="placeholder-glow">
                <div 
                  className="placeholder rounded-circle bg-secondary-subtle" 
                  style={{ width: '170px', height: '170px' }}
                ></div>
              </div>
            </div>
          </div>

          {/* Legend Skeleton */}
          <div>
            <div className="placeholder-glow mb-2">
              <span className="placeholder col-4 rounded" style={{ height: '16px' }}></span>
            </div>
            <div className="d-flex flex-column gap-2">
              {[1, 2, 3].map((i) => (
                <div key={i} className="p-2 rounded bg-light">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2 flex-grow-1">
                      <div className="placeholder-glow">
                        <span className="placeholder rounded" style={{ width: '24px', height: '24px' }}></span>
                      </div>
                      <div className="placeholder-glow flex-grow-1">
                        <span className="placeholder col-6 rounded mb-1" style={{ height: '14px' }}></span>
                        <span className="placeholder col-8 rounded" style={{ height: '12px' }}></span>
                      </div>
                    </div>
                    <div className="placeholder-glow text-end">
                      <span className="placeholder col-12 rounded mb-1" style={{ width: '60px', height: '14px' }}></span>
                      <span className="placeholder col-12 rounded" style={{ width: '60px', height: '12px' }}></span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeIn 0.6s ease-out;
        }

        /* Animation de pulsation pour les placeholders */
        .placeholder {
          animation: placeholder-glow 2s ease-in-out infinite;
        }

        @keyframes placeholder-glow {
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default ChartSkeleton;